/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { V1EarnedReward } from './V1EarnedReward'
import {
    V1EarnedRewardFromJSON,
    V1EarnedRewardFromJSONTyped,
    V1EarnedRewardToJSON,
    V1EarnedRewardToJSONTyped
} from './V1EarnedReward'
import type { V1ReferralReward } from './V1ReferralReward'
import {
    V1ReferralRewardFromJSON,
    V1ReferralRewardFromJSONTyped,
    V1ReferralRewardToJSON,
    V1ReferralRewardToJSONTyped
} from './V1ReferralReward'

/**
 *
 * @export
 * @interface V1ReferralProgram
 */
export interface V1ReferralProgram {
    /**
     *
     */
    programId: string
    /**
     *
     */
    name: string
    /**
     * Empty until the user takes one (ensureReferralCode)
     */
    code?: string
    /**
     * t.me link carrying the code
     */
    link?: string
    /**
     *
     */
    landingPath: string
    /**
     *
     */
    opened: number
    /**
     *
     */
    signedUp: number
    /**
     *
     */
    qualified: number
    /**
     *
     */
    endsAt?: number
    /**
     *
     */
    rewards: Array<V1ReferralReward>
    /**
     *
     */
    earned: Array<V1EarnedReward>
}

/**
 * Check if a given object implements the V1ReferralProgram interface.
 */
export function instanceOfV1ReferralProgram(
    value: object
): value is V1ReferralProgram {
    if (!('programId' in value) || value['programId'] === undefined)
        return false
    if (!('name' in value) || value['name'] === undefined) return false
    if (!('landingPath' in value) || value['landingPath'] === undefined)
        return false
    if (!('opened' in value) || value['opened'] === undefined) return false
    if (!('signedUp' in value) || value['signedUp'] === undefined) return false
    if (!('qualified' in value) || value['qualified'] === undefined)
        return false
    if (!('rewards' in value) || value['rewards'] === undefined) return false
    if (!('earned' in value) || value['earned'] === undefined) return false
    return true
}

export function V1ReferralProgramFromJSON(json: any): V1ReferralProgram {
    return V1ReferralProgramFromJSONTyped(json, false)
}

export function V1ReferralProgramFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean
): V1ReferralProgram {
    if (json == null) {
        return json
    }
    return {
        programId: json['programId'],
        name: json['name'],
        code: json['code'] == null ? undefined : json['code'],
        link: json['link'] == null ? undefined : json['link'],
        landingPath: json['landingPath'],
        opened: json['opened'],
        signedUp: json['signedUp'],
        qualified: json['qualified'],
        endsAt: json['endsAt'] == null ? undefined : json['endsAt'],
        rewards: (json['rewards'] as Array<any>).map(V1ReferralRewardFromJSON),
        earned: (json['earned'] as Array<any>).map(V1EarnedRewardFromJSON)
    }
}

export function V1ReferralProgramToJSON(json: any): V1ReferralProgram {
    return V1ReferralProgramToJSONTyped(json, false)
}

export function V1ReferralProgramToJSONTyped(
    value?: V1ReferralProgram | null,
    ignoreDiscriminator: boolean = false
): any {
    if (value == null) {
        return value
    }

    return {
        programId: value['programId'],
        name: value['name'],
        code: value['code'],
        link: value['link'],
        landingPath: value['landingPath'],
        opened: value['opened'],
        signedUp: value['signedUp'],
        qualified: value['qualified'],
        endsAt: value['endsAt'],
        rewards: (value['rewards'] as Array<any>).map(V1ReferralRewardToJSON),
        earned: (value['earned'] as Array<any>).map(V1EarnedRewardToJSON)
    }
}
